import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  DialogContentText,
  IconButton,
  TableCell,
  TableRow,
} from "@mui/material";
import Popup from "../../../../../components/common/model/Popup";
import closeIcon from "../../../../../assets/closeModel.png";
import useStyles from "../../../../../components/common/model/styles";
import React, { useEffect, useState } from "react";
import PageTitle from "../../../../../components/pageTitle/PageTitle";
import TableDesign from "../../../../../components/common/table/TableDesign";
import { tableHeadings } from "./utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ManageInventoryBingo from "./ManageInventoryBingo";
import AlertAssignCrew from "./AlertAssignCrew";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteInventoryAction,
  getInventoryCrewDetailsAction,
  sendInventoryCrewSendLinkAction,
  setDeleteInventoryResponseAction,
  setSendInventoryCrewSendLinkAction,
} from "../../../../../store/reducers/inventoryCrewSlice";
import dayjs from "dayjs";
import AlertPopup from "../../../../../components/common/alertPopup/AlertPopup";
import { setNotificationAction } from "../../../../../store/reducers/mmymSlice";
interface ManageInventorListProps {
  open: boolean;
  title: string;
  onHide: () => void;
  sourceRemovalId?: string | number | null;
  contractId?: string | number | null;
  readOnly?: boolean;
}

const ManageInventoryList: React.FC<ManageInventorListProps> = (props) => {
  const {
    open,
    title,
    onHide,
    sourceRemovalId,
    contractId,
    readOnly = false,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    isSendInventoryCrewSendLinkResponse,
    clientInventoryCrewDetails,
    isDeleteInventoryResponse,
  } = useSelector((state: any) => state.inventoryCrew || {});
  const { userProfile } = useSelector((state: any) => state?.user);
  const [showInventory, setShowInventory] = useState(false);
  const [assignCrewAlertModel, setAssignCrewAlertModel] = useState(false);
  const [actionAnchor, setActionAnchor] = useState<HTMLElement | null>(null);
  const [alertDeleteModelShow, setAlertDeleteModelShow] = useState(false);
  const [alertModelShow, setAlertModelShow] = useState(false);
  const [selectedCrewRow, setSelectedCrewRow] = useState<any>(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const hideHandler = () => {
    onHide();
    setSelectedCrewRow(null);
  };

  useEffect(() => {
    if (open && contractId) {
      dispatch(getInventoryCrewDetailsAction({ contractId, role: "admin" }));
    }
  }, [dispatch, open, contractId]);

  useEffect(() => {
    if (isDeleteInventoryResponse || isSendInventoryCrewSendLinkResponse) {
      dispatch(getInventoryCrewDetailsAction({ contractId, role: "admin" }));
      dispatch(setDeleteInventoryResponseAction(false));
      dispatch(setSendInventoryCrewSendLinkAction(false));
    }
  }, [
    dispatch,
    isDeleteInventoryResponse,
    isSendInventoryCrewSendLinkResponse,
  ]);

  const handleAssignCrew = () => {
    setAssignCrewAlertModel(true);
  };

  useEffect(() => {
    if (isSendInventoryCrewSendLinkResponse) {
      setAssignCrewAlertModel(false);
      setAlertModelShow(false);
      setDeleteConfirmOpen(false);
      setAlertDeleteModelShow(false);
      dispatch(setSendInventoryCrewSendLinkAction(false));
    }
  }, [dispatch, isSendInventoryCrewSendLinkResponse]);

  const handleActionClick = (event: any, inventory: any) => {
    event.stopPropagation();
    setActionAnchor(event.currentTarget);
    setSelectedCrewRow(inventory);
  };

  const handleViewInventory = () => {
    setActionAnchor(null);
    setShowInventory(true);
  };

  const confirmDeleteInventory = () => {
    if (contractId) {
      dispatch(deleteInventoryAction({ contractId }));
    }
  };

  useEffect(() => {
    if (isDeleteInventoryResponse) {
      setDeleteConfirmOpen(false);
      setAlertDeleteModelShow(false);
      setAlertModelShow(false);
      dispatch(setDeleteInventoryResponseAction(false));
    }
  }, [dispatch, isDeleteInventoryResponse]);

  const handleShowResendLink = () => {
    setActionAnchor(null);
    setAlertModelShow(true);
  };

  const handleShowDeleteInventory = () => {
    setActionAnchor(null);
    setAlertDeleteModelShow(true);
  };

  const handleResendLink = () => {
    console.log("selectedCrewRow", selectedCrewRow);
    if (contractId && (selectedCrewRow?.id || selectedCrewRow?.crew_email)) {
      dispatch(
        sendInventoryCrewSendLinkAction({
          crewId: selectedCrewRow?.inventory?.id || null,
          email: selectedCrewRow?.crew_email || null,
          contractId,
        }),
      );
    }
  };

  const handleDeleteInventory = () => {
    if (contractId && selectedCrewRow?.id) {
      dispatch(deleteInventoryAction({ inventoryId: selectedCrewRow?.id }));
    }
  };

  return (
    <>
      {(alertDeleteModelShow || alertModelShow) && (
        <AlertPopup
          open={alertDeleteModelShow || alertModelShow}
          onHide={() => {
            setAlertDeleteModelShow(false);
            setAlertModelShow(false);
            setSelectedCrewRow(null);
            dispatch(setNotificationAction({ message: [], severity: "error" }));
          }}
          title={"Alert"}
          content={
            alertDeleteModelShow
              ? "Are you sure you want to delete this inventory?"
              : "Are you sure you want to resend the link?"
          }
          submitHandler={
            alertDeleteModelShow ? handleDeleteInventory : handleResendLink
          }
        />
      )}
      {showInventory && (
        <ManageInventoryBingo
          show={showInventory}
          setShow={setShowInventory}
          selectedCrewRow={selectedCrewRow}
          readOnly={readOnly}
        />
      )}
      {assignCrewAlertModel && (
        <AlertAssignCrew
          open={assignCrewAlertModel}
          sourceRemovalId={sourceRemovalId}
          contractId={contractId}
          setAlertModelShow={setAssignCrewAlertModel}
          onHide={() => setAssignCrewAlertModel(false)}
          title="Alert"
          content="Are you sure you want to assign crew for this inventory?"
          isError={false}
          setIsValid={() => {}}
        />
      )}
      <Popup
        open={open && !showInventory}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"lg"}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent
          sx={{
            padding: "16px 10px !important",
          }}
        >
          <PageTitle
            title="Inventory Lists"
            button={readOnly ? "" : (
              clientInventoryCrewDetails?.inventory?.id
                ? ""
                : "+ Add Inventory Checklist"
            )}
            onClick={readOnly ? undefined : handleAssignCrew}
          />
          <DialogContentText>
            <TableDesign
              tableHeadings={tableHeadings}
              tableHeadColor={"#02906f"}
              cellColor={"#fff"}
              //   pagination={InvData?.length > 0 ? 1 : null}
              isLoader={false}
              stickyHeader={true}
              filterOption={() => {}}
              setFilterOption={() => {}}
              extraCSS={{
                height: "calc(100%)",
              }}
            >
              {clientInventoryCrewDetails?.inventory?.id ? (
                <TableRow
                  key={clientInventoryCrewDetails.inventory.id}
                  sx={{
                    cursor: "pointer",
                    marginTop: "10px",
                    padding: "4px !important",
                    borderRadius: "20px !important",
                    height: "20px !important",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                      outline: "2px solid #f0f0f0",
                      borderRadius: "0px !important",
                      outlineOffset: "-2px !important",
                    },
                  }}
                >
                  <TableCell>
                    {clientInventoryCrewDetails.inventory.title}
                  </TableCell>
                  <TableCell>
                    {clientInventoryCrewDetails.items.length > 0
                      ? clientInventoryCrewDetails.items.length
                      : 0}{" "}
                    items
                  </TableCell>

                  <TableCell>
                    {clientInventoryCrewDetails.inventory.status}
                  </TableCell>

                  <TableCell>
                    {dayjs(
                      clientInventoryCrewDetails.inventory.created_at,
                    ).format(
                      userProfile?.dateFormat
                        ? userProfile?.dateFormat
                        : "DD/MM/YYYY",
                    )}
                  </TableCell>

                  {/* Action */}
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={(event) =>
                        handleActionClick(
                          event,
                          clientInventoryCrewDetails.inventory,
                        )
                      }
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeadings?.length} align="center">
                    {`No Data Found!`}
                  </TableCell>
                </TableRow>
              )}
            </TableDesign>
          </DialogContentText>
        </DialogContent>
      </Popup>
      <Menu
        anchorEl={actionAnchor}
        open={Boolean(actionAnchor)}
        onClose={() => setActionAnchor(null)}
      >
        <MenuItem onClick={handleViewInventory}>View Inventory</MenuItem>
        {!readOnly && (
          <>
            <MenuItem onClick={handleShowResendLink}>Resend Link</MenuItem>
            <MenuItem onClick={handleShowDeleteInventory}>Delete</MenuItem>
          </>
        )}
      </Menu>
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
      >
        <DialogTitle>Delete inventory?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this inventory?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmOpen(false)}>Cancel</Button>
          <Button color="error" onClick={confirmDeleteInventory}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManageInventoryList;
